'use client';

import { useIsTouchDevice } from '@darkroom.engineering/hamo';
import { useEffect } from 'react';

export function RealViewport() {
  const touchDevice = useIsTouchDevice();

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--vh',
      `${window.innerHeight * 0.01}px`
    );

    function onWindowResize() {
      if (!touchDevice) {
        document.documentElement.style.setProperty(
          '--vh',
          `${window.innerHeight * 0.01}px`
        );
      }
    }

    window.addEventListener('resize', onWindowResize, false);
    onWindowResize();

    return () => {
      window.removeEventListener('resize', onWindowResize, false);
    };
  }, []);

  return null;
}
